import format from 'date-fns/format'
import { enGB, de } from 'date-fns/locale'
import parseISO from 'date-fns/parseISO'

import { Locale } from 'src/enum/Locale'

export const formatDate = (isoDate: string, locale: Locale, units: string = 'PPP'): string => {
  const date = parseISO(isoDate)

  return format(date, units, {
    locale: locale === Locale.enGB ? enGB : de,
  })
}
